module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"logout":"Logout"},"in":{"logout":"Keluar"}}')
  delete Component.options._Ctor
}
